import { useMemo } from 'react';

import { UserCommunication } from '@this+that/models';

export const useHasMultipleEmailAddresses = (
  communications: UserCommunication[],
  selectedItems: Set<string>,
): { hasMultipleEmailAddresses: boolean } => {
  const hasMultipleEmailAddresses = useMemo(() => {
    const selectedCommunications = communications.filter((comm) =>
      selectedItems.has(comm.messageId),
    );

    if (selectedCommunications.length === 0) {
      return false;
    }

    const uniqueEmailAddresses = new Set(
      selectedCommunications
        .map((comm) => comm.userEmailAddress)
        .filter((address) => address !== undefined),
    );

    return uniqueEmailAddresses.size > 1;
  }, [communications, selectedItems]);

  return { hasMultipleEmailAddresses };
};
